import { Box, Grid, styled } from '@mui/material'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'
import Logo from 'assets/logo.png'
import InstallLayout from 'router/layouts/InstallLayout'
import NewVersion from './NewVersion'
import LoadingDot from './LoadingDot'

interface IInstallingSplashScreen {
    isNewVersion?: boolean
}

const ImageContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    [theme.breakpoints.down('md')]: {
        justifyContent: 'center',
    },
    [theme.breakpoints.up('md')]: {
        justifyContent: 'flex-end',
    },
}))

const ImageContainerNoNewInstalling = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
}))

function InstallingSplashScreen({
    isNewVersion = false,
}: IInstallingSplashScreen) {
    const { isMobile } = useScreenSize()
    return (
        <InstallLayout container alignItems="center">
            <Grid item container alignItems="center" spacing={2}>
                <Grid item xs>
                    {isNewVersion ? (
                        <ImageContainer>
                            <img
                                style={{
                                    width: isMobile ? 340 : 412,
                                }}
                                src={Logo}
                                alt="logo"
                            />
                        </ImageContainer>
                    ) : (
                        <ImageContainerNoNewInstalling>
                            <img
                                style={{
                                    width: isMobile ? 340 : 412,
                                }}
                                src={Logo}
                                alt="logo"
                            />
                        </ImageContainerNoNewInstalling>
                    )}
                </Grid>
                {isNewVersion ? (
                    <Grid item md={6} xs={12}>
                        <NewVersion />
                    </Grid>
                ) : (
                    <Grid item xs={12}>
                        <LoadingDot />
                    </Grid>
                )}
            </Grid>
        </InstallLayout>
    )
}
export default InstallingSplashScreen
